import React from "react";
import { Helmet } from "react-helmet";
import "./ContactPage.css"; // ייבוא העיצוב של הדף
import ContactForm from "../../components/Contactusform/ContactusForm";
import { Mail } from 'lucide-react'; // ניתן להחליף לכל אייקון אחר
import Ads1200100 from "../../components/Ads1200100/Ads1200100";
import QandAforcontactus from "../../components/HeroSectionHomepage/QandAforContactus/QandAforContactus";
const ContacPage = () => {
  return (
    <>
    <Helmet>
      {/* Title & Description */}
      <title>צור קשר | BuyTaxi - קנה טקסי</title>
      <meta name="description" content="צור קשר עם צוות BuyTaxi לכל שאלה בנושא קניית מוניות, זכויות ציבוריות, מוניות בפיקס וביטוח למונית." />

      {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
      <meta property="og:title" content="צור קשר | BuyTaxi - קנה טקסי" />
      <meta property="og:description" content="שאלות על קניית מוניות או זכויות ציבוריות? BuyTaxi כאן כדי לעזור!" />
      <meta property="og:image" content="%PUBLIC_URL%/og-image.jpg" />
      <meta property="og:url" content="https://buytaxi.co.il/contact" />
      <meta property="og:type" content="website" />
      <meta name="keywords" content="קניית מוניות, מוניות למכירה, רכישת מונית, מכירת מונית, זכויות ציבוריות, רכישת זכויות ציבוריות, ביטוח למונית, ביטוח מוניות, BuyTaxi, קנה טקסי, ליסינג למוניות, השכרת מוניות, מוניות יד שנייה, מוניות פיקס, מוניות פיקס למכירה, טרייד אין למוניות, מונית חדשה, מונית משומשת, שוק המוניות, מוניות לעסק, מסלולי מימון למוניות, מימון לרכישת מוניות, מימון מונית, מונית ספיישל, תחנות מוניות, לוח מוניות למכירה, הזדמנויות עסקיות במוניות, תיווך מוניות, מציאת נהג למונית, קנייה בטוחה של מוניות, השקעה במוניות, ביטוח חובה למונית, ביטוח מקיף למונית, ביטוח צד ג' למונית, נהגים למוניות, ליסינג מימוני למוניות, ליסינג תפעולי למוניות, מס ליסינג מוניות, מחירי מוניות, דגמי מוניות מומלצים, מוניות במימון מלא, הלוואות למוניות, מוניות חשמליות, מוניות היברידיות, מונית VIP, מונית יוקרה, מוניות נגישות, מונית נגישה לנכים, תחנות מוניות בישראל, נהגי מוניות, עבודה כנהג מונית, רישוי מוניות, חוקים למוניות, קניית זכות ציבורית, מכירת זכות ציבורית, שווי זכויות ציבוריות למונית, קנייה בטוחה של זכויות ציבוריות, איך לקנות מונית, איך למכור מונית, פורום נהגי מוניות, קבוצות פייסבוק למוניות" />

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="צור קשר | BuyTaxi - קנה טקסי" />
      <meta name="twitter:description" content="שאלות על קניית מוניות או זכויות ציבוריות? BuyTaxi כאן כדי לעזור!" />
      <meta name="twitter:image" content="%PUBLIC_URL%/og-image.jpg" />
      <meta name="twitter:site" content="@buytaxi" />

      {/* Canonical URL (מניעת כפילות תוכן) */}
      <link rel="canonical" href="https://buytaxi.co.il/contact" />
    </Helmet>
    <div className="Contact-container">
        <div className="HeaderContact">
        </div>
        <div className="ContactusPageUltimate">
          <div className="ContactPageAds1200100">
            <Ads1200100 />
          </div>
        <div className="ContactPageFormTitle">
        <h2 className="ContactPageFormTitleh2">
  <Mail size={24} className="ContactPageFormIcon" /> צור קשר
</h2>
        </div>
        <div className="ContactUsformatpage">
          <ContactForm />
          <QandAforcontactus />
          
        </div>
        
        </div>
    </div>
    </>
  );
};

export default ContacPage;
